import { EppoFeatureFlagsConfig } from "src/types/featureFlags";

export const featureFlagsConfig: EppoFeatureFlagsConfig = {
  enableWishListCarousel: {
    flagKey: "wishlist-carousel",
    defaultValue: false,
    options: {
      is_wishlist_user: "",
    },
  },
  enableWishListCarouselOnCart: {
    flagKey: "wishlist-carousel-on-cart",
    defaultValue: false,
  },
  enableAugmentedSearch: {
    flagKey: "augmented-search-multivariate",
    defaultValue: "original",
    options: {
      locale: "",
    },
  },
  pdpCarouselRecommender: {
    flagKey: "pdp-carousel-you-may-also-like-recommender",
    defaultValue: "basic",
    options: {
      email: "",
    },
  },
  pdpTrendingCarouselRecommender: {
    flagKey: "web-pdp-carousel-trending-now-recommender",
    defaultValue: "basic",
    options: {
      email: "",
    },
  },
  homepageNewInCarouselRecommender: {
    flagKey: "web-carousel-homepage-new-in-recommender",
    defaultValue: "basic",
    options: {
      email: "",
    },
  },
  // Per store key, the Constructor pod and title of the homepage recommendations carousel
  // (src/utils/homepageRecommendationsFlag.ts). The name leaves out "carousel" so visitors who
  // aren't signed in are evaluated too; see the filter in EppoRandomizationProvider.
  homepageRecommendations: {
    flagKey: "web-homepage-recommendations",
    defaultValue: {},
  },
  cartAlertBanner: {
    flagKey: "alert-banner-shopping-cart-web",
    defaultValue: { nl: "" },
    options: {
      email: "",
    },
  },
  cartYMALCarouselRecommender: {
    flagKey: "web-carousel-cart-ymal-recommender",
    defaultValue: "basic",
    options: {
      email: "",
    },
  },
  enableGatedHomepage: {
    flagKey: "gate-homepage-enabled",
    defaultValue: false,
    options: {
      locale: "",
    },
  },
  enableMolliePerStore: {
    flagKey: "web-psp-mollie-store-enabled",
    defaultValue: {},
  },
  enableSeoContent: {
    flagKey: "seo-content-enabled",
    defaultValue: false,
    options: {
      locale: "",
    },
  },
  enablePLPIndexation: {
    flagKey: "web-enable-plp-indexation",
    defaultValue: false,
    options: {
      locale: "",
    },
  },
  enabledAccountDeletion: {
    flagKey: "web-enable-account-deletion",
    defaultValue: false,
    options: {
      locale: "",
    },
  },
  sizingFiltersWithSchema: {
    flagKey: "sizing_filters_with_schema",
    defaultValue: false,
  },
  sizeSelectorMappingsEnabled: {
    flagKey: "size_selector_mappings_enabled",
    defaultValue: false,
  },
  storeCreditActive: {
    flagKey: "store_credit_active",
    defaultValue: false,
  },
  multipleCouponsAndStoreCreditEnabled: {
    flagKey: "is_multiple_coupons_and_store_credit_enabled",
    defaultValue: false,
  },
  coframeEnabled: {
    flagKey: "coframe_enabled",
    defaultValue: false,
  },
  showAllInPrimaryNav: {
    flagKey: "Show-All-In-Primary-Nav",
    defaultValue: false,
  },
  showOutOfStockVariants: {
    flagKey: "Show-Out-of-Stock-Variants",
    defaultValue: false,
  },
  freeShippingThreshold: {
    flagKey: "free-shipping-threshold",
    defaultValue: {},
    options: {
      email: "",
    },
  },
  // Routes a 50/50 split of all recommendation-carousel traffic (PDP similar/trending,
  // cart cross-sell, homepage new-in) between the AWS and Constructor recommendation engines.
  // Applies to anonymous traffic too, so its name intentionally omits "carousel" — see the
  // anonymous-user flag filter in EppoRandomizationProvider.
  recommendationEngineRouting: {
    flagKey: "recommendation-engine-routing",
    defaultValue: "constructor",
  },

  showGuestReturnForm: {
    flagKey: "show-guest-return-form",
    defaultValue: false,
  },
  // Temporary trigger for emitting the right to be forgotten event while the
  // customer-facing request flow is still being designed.
  rightToBeForgottenVisible: {
    flagKey: "Right-to-be-Forgotten-Visible",
    defaultValue: false,
  },
  geoRedirectCardEnabled: {
    flagKey: "web-geo-redirect-card",
    defaultValue: false,
    options: {
      locale: "",
    },
  },
  googleOneTapEnabled: {
    flagKey: "google-one-tap-enabled",
    defaultValue: false,
    options: {
      locale: "",
    },
  },
  // Add more feature flags here with Eppo configurations
};

export const defaultFeatureFlags = {
  enableWishListCarousel: null,
  enableWishListCarouselOnCart: null,
  enableAugmentedSearch: null,
  pdpCarouselRecommender: "basic",
  pdpTrendingCarouselRecommender: "basic",
  homepageNewInCarouselRecommender: "basic",
  homepageRecommendations: {},
  cartYMALCarouselRecommender: "basic",
  cartAlertBanner: { nl: "" },
  enableGatedHomepage: null,
  enableMolliePerStore: {},
  enableSeoContent: null,
  enabledAccountDeletion: false,
  enablePLPIndexation: false,
  sizingFiltersWithSchema: false,
  sizeSelectorMappingsEnabled: false,
  storeCreditActive: false,
  multipleCouponsAndStoreCreditEnabled: false,
  coframeEnabled: false,
  showAllInPrimaryNav: false,
  showOutOfStockVariants: false,
  freeShippingThreshold: {},
  recommendationEngineRouting: "constructor",
  showGuestReturnForm: false,
  rightToBeForgottenVisible: false,
  geoRedirectCardEnabled: false,
  googleOneTapEnabled: false,
};
